import { BackendModel, BackendService } from "../../../core/backend.service";

export class ProductosBuscadoAgrupadoHistorial extends BackendModel {

    static path:string = '/new-productos/';
    texto:string;
    cantidad:number;
    encontrado: boolean;


  constructor(protected backendService: BackendService, model?: ProductosBuscadoAgrupadoHistorial) {
      super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/productos-buscados/models/producto-buscado-agrupado-historial.model.ts